<div class="collab-list-item-container user-img-show-indicator">
    <div class="collab-list-item-user-image">
        <user-image
            imageSize="small"
            [hasImage]="false"
            [imagePath]="false"
            [userInitials]="groupShare.group?.initials || 'GR'"
            [userRegistered]="true">
        </user-image>
    </div>
    <div class="collab-list-item-inner">
        <p class="collab-list-item-collab-name fx-ellipsis body">{{groupShare.group?.displayName || 'Unknown Group'}}</p>
        <p class="collab-list-item-collab-email fx-ellipsis grey caption">{{groupShare.group?.description || ''}}</p>
    </div>
    <div class="collab-list-item-dropdown">
        <alter-collab-dropdown #dropdown theme="dark"
            *ngIf="mutableCollabType()"
            [excludeCollabTypes]="imutableCollabTypes"
            [selectedValue]="selectedRole | async" translate>
        </alter-collab-dropdown>
        <div *ngIf="!mutableCollabType()" class="collab-list-item-owner body">{{getCollabTypeName() | async}}</div>
    </div>
</div>